import ReactMarkdown from 'react-markdown';
import type { Message } from '../types';
import { TesterComment } from './TesterComment';

interface ChatMessageProps {
  message: Message;
  messageIndex: number;
  onButtonClick: (value: string, label: string) => void;
  isLast: boolean;
  isTesterMode?: boolean;
  testerComment?: string;
  onTesterComment?: (messageIndex: number, kommentar: string) => void;
}

export function ChatMessage({ message, messageIndex, onButtonClick, isLast, isTesterMode, testerComment, onTesterComment }: ChatMessageProps) {
  return (
    <div className={`message message-${message.role}`}>
      <div className="message-bubble">
        <ReactMarkdown
          components={{
            // Links in neuem Tab öffnen
            a: ({ href, children }) => (
              <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
            ),
          }}
        >
          {message.content}
        </ReactMarkdown>

        {isLast && message.buttons && message.buttons.length > 0 && (
          <div className="button-group">
            {message.buttons.map((button, index) => (
              <button
                key={index}
                className={`chat-button ${button.primary ? 'chat-button-primary' : ''}`}
                onClick={() => onButtonClick(button.value, button.label)}
              >
                {button.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {isTesterMode && message.role === 'assistant' && onTesterComment && (
        <TesterComment
          messageIndex={messageIndex}
          existingComment={testerComment}
          onSave={onTesterComment}
        />
      )}
    </div>
  );
}
